import { OpenAIResponse } from "./OpenAIResponse";
import { IOpenAIPlugin } from "./IOpenAIPlugin";
import OpenAI from "openai";
import { DataUtilities } from "../../Common/DataUtilities";
import { PromptDataWithId } from "./PromptDataWithId";

export class OpenAIPlugin implements IOpenAIPlugin {
    static MAX_TOKENS = 2000;

    // this is a required element of the openai plugin.  the key is used to establish credentials with OpenAI.
    apiKey: string;

    constructor(apiKey: string) {
        this.apiKey = apiKey;
    }

    async chatWithAI(
        question: string,
        maxTokens?: number,
        lastResponse?: OpenAIResponse<string>
    ): Promise<OpenAIResponse<string>> {
        let openai = new OpenAI({
            apiKey: this.apiKey,
            dangerouslyAllowBrowser: true,
        });

        let promptData: OpenAI.Chat.ChatCompletionMessageParam[] = [];

        if (lastResponse) {
            for (let r of lastResponse.messages) {
                promptData.push(r.messageParam);
            }
        }

        promptData.push({
            role: "user",
            content: question,
        });

        try {
            const response = await openai.chat.completions.create({
                model: "gpt-3.5-turbo",
                messages: promptData,
                temperature: 0.6,
                max_tokens: maxTokens ?? OpenAIPlugin.MAX_TOKENS,
            });

            let promptDataWithId: PromptDataWithId[] = lastResponse?.messages ?? [];

            promptDataWithId.push({
                messageParam: {
                    role: "user",
                    content: question,
                },
                id: DataUtilities.generateUniqueId(),
            });

            promptDataWithId.push({
                messageParam: {
                    role: "assistant",
                    content: response.choices[0].message!.content,
                },
                id: DataUtilities.generateUniqueId(),
            });

            return new OpenAIResponse<string>(response.choices[0].message!.content ?? "", promptDataWithId);
        } catch (e) {
            console.log(e);
            throw new Error("OpenAI Error: " + e.message);
        }
    }
}
